// const BASE_URL = "http://localhost:5035/scanner-api/";
const BASE_URL = "https://aivoice.allkalki.com/scanner-api/";


//////////////pdf upload//////
export const POST_QRCODE = `${BASE_URL}qrcodeinfo`;

export const GET_INFO_BY_SRNO = `${BASE_URL}info/bysrno`;

//////////member///////////
export const POST_MEMBER_API = `${BASE_URL}post/member`;

//////////admin////////
export const POST_SINGLE_POSTER = `${BASE_URL}addposter`;
export const POST_POSTER = `${BASE_URL}uploadposterdata`;
export const GET_POSTER = `${BASE_URL}posterdata`;
export const GET_POSTER_BY_ID = `${BASE_URL}info/bysrno`;  // 🔧 fixed here
export const DELETE_POSTER = `${BASE_URL}deleteposter`;
export const UPDATE_POSTER = `${BASE_URL}updateposter`;
export const GET_LANGUAGE = `${BASE_URL}languages`;
